var locale = {
  placeholder: '请选择时间'
};
export default locale;
//# sourceMappingURL=zh_CN.js.map
